export default "/images/sis_icon.svg"